import en from './en.json'
import fr from './fr.json'
import es from './es.json'
import de from './de.json'
import nl from './nl.json'
import ca from './ca.json'
import ar from './ar.json'

const i18nextRessourrces = {
  en,
  fr,
  es,
  de,
  nl,
  ca,
  ar
}

export default i18nextRessourrces
